import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import SequenceCard from './SequenceCard'
import '../assets/css/components/module-sequences.css'
import { OnboardingTeacherContext } from '../contexts/OnboardingTeacherContextProvider'
import { handleTaskComplete, convertTeacherStartTrack, status, step_id } from './OnboardingHomepage/onboardingUtils'

const ModuleSequences = ({ module }) => {
  return (
    <div className='module-subpage module-sequences'>
      <h1 className='semi-bold'>Storylines</h1>
      <p className='subtitle'>Pre-designed storylines within the topic that lead students through building their knowledge until they have mastered the bundle of standards. Click through to read more about each Sequence and assign all or part to your students.</p>

      {_.map(_.orderBy(module.sequences, sequence => sequence.module_rank), (sequence, id) => {
        return (<SequenceCard key={id} sequence={sequence} />)
      })}
    </div>
  )
}

ModuleSequences.propTypes = {
  module: PropTypes.object.isRequired
}

export default ModuleSequences

